import { LoadableAfterPaint } from '@confluence/loadable';

export const EditorControlsBannerLoader = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-EditorControlsBanner" */ './EditorControlsBanner'))
			.EditorControlsBanner,
});
